<template>
  <div class="intro-text">
    <div class="intro-text_lockup ">
      <label class="block-heading-font-style">our platform</label>
    </div>

    <div class="intro-text_body">
      <p v-for="block in introText" v-html="block"></p>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    if (!window.sr) window.sr = ScrollReveal()
    window.sr.reveal('.intro-text', { delay: 250, duration: 500 })
  },
  methods: {},
  computed: {
    introText() {
      return this.$store.state.introText
    }
  },
  watch: {}
}
</script>

<style scoped>

  .intro-text {
    background: white;
    padding-bottom: 12px;
  }

  .intro-text_body {
    display: block;
  }

  .intro-text_body p {
    color: #333;
    font-family: 'Work Sans', sans-serif;
    display: block;
    font-size: 21px;
    width: 55%;
    margin: 0 auto;
    margin-bottom: 24px;
  }

  @media only screen and (max-width: 450px) {
    .intro-text_body p {
      width: 65%;
    }
  }

  .intro-text_body p a {
    font-family: 'Work Sans', sans-serif;
    color: black;
  }

  .intro-text_lockup {
    display: block;
    text-align: center;
    padding: 24px 0;
  }
</style>



// WEBPACK FOOTER //
// IntroText.vue?de7c29c8